import { Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

const MainCanvasLazy = React.lazy(() => import('./MainCanvas'))

export type MainCanvasSuspenseProps = BoxProps & {}

const MainCanvasSuspense: React.FC<MainCanvasSuspenseProps> = ({ ...others }) => {
  const isSSR = typeof window === 'undefined'

  return (
    <>
      <Box pos="fixed" top="0" left="0" right="0" bottom="0" {...others}>
        {!isSSR && (
          <React.Suspense fallback={<div />}>
            <MainCanvasLazy />
          </React.Suspense>
        )}
      </Box>
    </>
  )
}

export default MainCanvasSuspense
